import { hash } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import BasicDropdown from 'ember-basic-dropdown/components/basic-dropdown';
import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { eq, isEmpty, lt, not } from 'ember-truth-helpers';

import { CircularProgress } from 'umg-ember-backend/components/ui/circular-progress';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class ApplicationHeaderFileQueue extends Component {
  // Services
  @service assetUploader;
  @service fileQueue;

  // Functions
  linkDropdown = (dropdown) => {
    this.assetUploader.dropdown = dropdown;
  };

  // Template
  <template>
    <BasicDropdown
      @horizontalPosition='right'
      @initiallyOpened={{false}}
      as |dropdown|
    >
      {{this.linkDropdown dropdown}}
      {{#if this.assetUploader.history.size}}
        <dropdown.Trigger class={{bem 'trigger'}}>
          {{#if (lt this.fileQueue.progress 100)}}
            <CircularProgress
              @progress={{this.fileQueue.progress}}
              class={{bem 'progress'}}
            />

            {{this.fileQueue.progress}}
          {{else}}
            {{svgJar
              'upload'
              class=(bem 'upload')
              aria-hidden='true'
              focusable='false'
            }}
          {{/if}}
        </dropdown.Trigger>

        <dropdown.Content class={{bem 'list'}}>
          <div class={{bem 'header'}}>
            {{#if this.fileQueue.files}}
              {{t
                'application.header.queue.uploading_files'
                fileCount=this.fileQueue.files.length
              }}
            {{else}}
              {{t
                'application.header.queue.uploaded_files'
                assetCount=this.assetUploader.history.size
              }}
            {{/if}}
          </div>
          {{#each-in this.assetUploader.history as |key item|}}
            <LinkTo
              @route='admin.assets.asset'
              @model={{item.asset}}
              @disabled={{item.asset.isNew}}
              class={{bem
                'item'
                (hash
                  is-upload-completed=(eq item.file.state 'uploaded')
                  is-upload-failed=(not (isEmpty item.asset.adapterError))
                )
              }}
            >
              <div class={{bem 'name'}}>
                {{item.asset.headline}}
              </div>
              <div class={{bem 'status'}}>
                {{#if (lt item.file.progress 100)}}
                  <CircularProgress
                    @progress={{item.file.progress}}
                    class={{bem 'progress'}}
                  />
                {{else}}
                  {{#if item.asset.adapterError}}
                    {{svgJar
                      'error'
                      class=(bem 'error')
                      aria-hidden='true'
                      focusable='false'
                    }}
                  {{else if item.asset.isNew}}
                    {{svgJar
                      'loading'
                      class=(bem 'spinner')
                      aria-hidden='true'
                      focusable='false'
                    }}
                  {{else}}
                    {{svgJar
                      'success'
                      class=(bem 'check')
                      aria-hidden='true'
                      focusable='false'
                    }}
                  {{/if}}
                {{/if}}
              </div>
            </LinkTo>
          {{/each-in}}
        </dropdown.Content>
      {{/if}}
    </BasicDropdown>
  </template>
}
